import StyledModal from './styled_modal';

export default StyledModal;
